import React from "react"
import CustomTable from "../../components/CustomTable";
import { addFieldofstudyName, editFieldofstudyName, getAllFieldsAndStudy, studyUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import { AddButton } from "../../components/masterDataForm/AddButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import EditMasterFormWithCountryCode from "../../components/masterDataForm/EditMasterFormWithCountryCode";
import AddMasterDataWithCountryCode from "../../components/masterDataForm/AddMasterDataWithCountryCode";
const FieldsOfStudy = () => {

    const dispatch = useDispatch();
    const studyInfo = useSelector(state => state?.getAllStudy?.study)

    const [showFieldsOfStudy, setFieldsOfStudyShow] = React.useState(false);
    const [showAddStudy, setAddStudyShow] = React.useState(false);
    const [studyValName, setStudyValName] = React.useState();
    


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllFieldsAndStudy();
                dispatch({ type: 'GET_ALL_STUDY', payload: res?.data?.data})
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        fetchUsers();
    }, [dispatch]);

    const addStudyHandle = async (studyName) => {
        try {
            const addFieldofstudyNames = await addFieldofstudyName(studyName);
            if(addFieldofstudyNames.status === 200) {
                dispatch({ type: 'ADD_STUDY_NAME', payload: addFieldofstudyNames.data?.data})
                toast.success(addFieldofstudyNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const editStudyHandle = async (study) => {
        try {
            // const studyPayload = {
            //     studyId: study?.statusId,
            //     name: study?.name
            // }
            const studyPayload = {
                studyId: study?.statusId,
                name: study?.name,
                isoCode: study?.isoCode
            }
            const editStudyNames = await editFieldofstudyName(studyPayload);
            if(editStudyNames.status === 200) {
                dispatch({ type: 'UPDATE_STUDY_NAME', payload: editStudyNames.data?.data})
                toast.success(editStudyNames.data?.message)
                return;
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };
    
    const studyApprovedAndUnAprooved = async (studyId) => {
        try {
            const approvedAndUnapprovedStatus = await studyUpdateApprovedAndUnapproved(studyId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_STUDY_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }

    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={studyApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data._id} isoCode={val.data?.isoCode}  hadnleEditName={setStudyValName} handleEditBtn={setFieldsOfStudyShow} />) }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Fields Of Study</h3>
            </div>
            <AddButton formName="Study" handleAddBtn={setAddStudyShow}  />
            <CustomTable colDefs={colDefs} rowData={studyInfo} />
            <AddMasterDataWithCountryCode formName="Study" addMasterData={addStudyHandle} showAddForm={showAddStudy} setShowAddForm={setAddStudyShow} />
            <EditMasterFormWithCountryCode formName="Study" editMasterDataName={studyValName} editMasterData={editStudyHandle} showEditForm={showFieldsOfStudy} setShowEditForm={setFieldsOfStudyShow}/>
        </React.Fragment>
    )
};
export default FieldsOfStudy;